import { render } from "./modal-v3.vue?vue&type=template&id=3c45f36d&ts=true"
import script from "./modal-v3.vue?vue&type=script&lang=ts"
export * from "./modal-v3.vue?vue&type=script&lang=ts"

import "./modal-v3.vue?vue&type=style&index=0&id=3c45f36d&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__